export const ROUTES = {
    HOME_PAGE: '/',
    FEELINGS_PAGE: '/feeling',
    RESULT_PAGE: '/result',
    FILTER_PAGE: '/filter',
    LOGIN_PAGE: '/login',
    ACCOUNT_PAGE: '/account',
    RESET_PASSWORD: '/reset-password',
};
